// extracted by mini-css-extract-plugin
export default {"inside":"Preloader_inside__pUZgC","outside":"Preloader_outside__vLQBS"};